module.exports = __webpack_public_path__ + "20fbf97316c9dbb78ccc4b21552e61b7.svg";